import { Component, Input } from "@angular/core";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";

@Component({
    selector: "drag-and-drop-group",
    templateUrl: "./drag-and-drop-group.tmpl.html",
    styleUrl: "./drag-and-drop-group.component.scss",
    standalone: false
})
export class DragAndDropGroupComponent<T extends object = Record<string, unknown>>
{
    @Input() readonly title: string;

    @Input() readonly items: Array<T>;

    @Input() readonly displayProperty: keyof T;

    getDisplay(item: T): string
    {
        return item[this.displayProperty]?.toString();
    }

    onCdkDropListDropped(event: CdkDragDrop<Array<T>>): void
    {
        moveItemInArray<T>(this.items, event.previousIndex, event.currentIndex);
    }
}
